export enum StorageKey {
    httpCache = 'HTTP_CACHE',
    municipalities = 'MUNICIPALITIES',
    commonFilters = 'COMMON_FILTERS',
    alertsFilters = 'ALERTS_FILTERS',
    servicesFilters = 'SERVICES_FILTERS',
    userFilters = 'USERS_FILTERS',
    backOfficeFilters = 'BACK_OFFICE_FILTERS',
    operatorsFilters = 'OPERATORS_FILTERS',
    globalSchedulerFilters = 'GLOBAL_SCHEDULER_FILTERS',
    assetsFilters = 'ASSETS_FILTERS',
    structuresFilters = 'STRUCTURES_FILTERS',
    vehiclesFilters = 'VEHICLES_FILTERS',
    userChatsFilters = 'USERS_CHATS_FILTERS',
    badgingNotesFilters = 'BADGING_NOTES_FILTERS',
}
